var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNorth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon-north",
    viewBox: "0 0 25 25",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.icons_fill {\r\n\t\t\tfill: currentColor;\r\n\t\t\tstroke: none;\r\n\t\t}\r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icons_fill",
    d: "M12.5,1C6.149,1,1,6.149,1,12.5C1,18.851,6.149,24,12.5,24C18.851,24,24,18.851,24,12.5 C24,6.149,18.851,1,12.5,1z M12.5,22.5c-5.514,0-10-4.486-10-10c0-5.09,3.825-9.295,8.75-9.913V12.5h2.5V2.587 C18.675,3.205,22.5,7.41,22.5,12.5C22.5,18.014,18.014,22.5,12.5,22.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNorth);
export default __webpack_public_path__ + "static/media/icon-north.490152c8935afe5dc0478ca0adaff981.svg";
export { ForwardRef as ReactComponent };